import { useEffect, useState } from 'react';
import './FilterNotificationRecipients.scss';
import { InputLabel, MenuItem, FormControl, Select, Box } from '@mui/material';
import SPUserCard from '../UserCard/SPUserCard';
import UserSearchBar from '../UserSearchBar/UserSearchBar';
import useScrollPosition from '../../../hooks/useScrollPosition';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const FilterNotificationRecipients = () => {
  const scrollPosition = useScrollPosition();

  const [showHideSelect, setShowHideSelect] = useState(false)
const {notificationRecipients, notificationTypes} = useSelector((state: any) => state.notification);
const {filterUsers,showingUsers} = useSelector((state: any) => state.sellerProfile);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (scrollPosition) {
      setShowHideSelect(false)
    }
  }, [scrollPosition]);

  const [selectedFilter, setSelectedFilter] = useState([
    'notifications',
    'All'
  ]);
  const resetSelectedFilter = () => {
    setSelectedFilter(['notifications', 'All']);
  };
  const notification_type = `notification_type_${i18n.language}`;
  const handleFilterChange = (e) => {
    setSelectedFilter(['notifications', e.target.value]);
  };
  const recipientNames: string[] = [];
  notificationRecipients?.forEach((user) => {
    recipientNames.push(user.user_first_name);
    recipientNames.push(user.user_last_name);
  });
  let showFilter = true;
  if (filterUsers.length > 0) {
    const getFilteredUsers = notificationRecipients.filter(
      (user) =>
        filterUsers.includes(user.user_first_name) ||
        filterUsers.includes(user.user_last_name)
    );
    showFilter = getFilteredUsers.length > 0;
  }

  return (
    <Box className="NewRecipientNotificationBox">
      <UserSearchBar resetSelectedFilter={resetSelectedFilter} />
      {showingUsers === 'true' && showFilter && (
        <Box className="notificationBox">
          <FormControl fullWidth variant="standard">
            <InputLabel id="demo-simple-select-label">
              {t('sellerProfile.dashboard.showRecipients')}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedFilter[1]}
              label="Show recipients of"
              onChange={handleFilterChange}
              open={showHideSelect}
              onOpen={() => setShowHideSelect(true)}
              onClose={() => setShowHideSelect(false)}
              MenuProps={{
                PaperProps: {
                  style: {
                    width: 1
                  }
                },
                disableScrollLock: true
              }}
            >
              <MenuItem value="All">
                {t('sellerProfile.dashboard.allNotifications')}
              </MenuItem>
              {notificationTypes?.map((type, i) => {
                return (
                  <MenuItem
                    value={type.notification_type_id}
                    key={`notifFilter${i}`}
                    sx={{ whiteSpace: 'normal' }}
                  >
                    {type[notification_type]}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>
      )}
      <Box className="notificationList">
        <SPUserCard cardType="notifications" filter={selectedFilter} />
      </Box>
    </Box>
  );
};

export default FilterNotificationRecipients;
